import { apiRequest } from '@/shared/api';
import type { LearningLanguage } from '@/entities/user';
import type { StreakSummary } from '../model/types';

export function getStreak(signal?: AbortSignal): Promise<StreakSummary> {
  return apiRequest<StreakSummary>('/me/streak', { signal });
}

export function sendPracticeTime(
  seconds: number,
  language: LearningLanguage,
  keepalive = false,
): Promise<{ credited: number }> {
  return apiRequest('/me/practice-time', { method: 'POST', body: { seconds, language }, keepalive });
}
